import React from 'react';
import { Link } from 'react-router';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
// images
import imgHeaderBg from '../../img/404-bg.png';
// translate
import messages from './messages';

function ErrorPage(props) {
  const { intl } = props;
  return (
    <div>
      <div
        className="error-404-wrap container-fluid"
        style={{ backgroundImage: `url('${imgHeaderBg}')` }}
      >
        <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <p className="error-404-text">
                  <FormattedHTMLMessage {...messages.text} />
                  <Link to="/">
                    {intl.formatMessage(messages.homepage)}
                  </Link>
                  {' '}{intl.formatMessage(messages.or)}{' '}
                  <a href="https://art.art/contact/">
                    {intl.formatMessage(messages.contact)}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ErrorPage.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(ErrorPage);



// WEBPACK FOOTER //
// ./src/pages/ErrorPage/index.js